import React from 'react';
import SearchContactStep from 'pages/components/SearchContactStep';

const ScreeningSearchContactStep = (props) => (
  <SearchContactStep {...props} />
);

export default ScreeningSearchContactStep;
